class MBWait {
    constructor() {
        this._init()
    }
    _init() {
        this.el = document.querySelector('[data-mbwait]')
        if(!this.el) {
            return;
        }

        this.elLoading = this.el.querySelector('[data-loading]')

        this.idPedido = "" + this.el.dataset.mbwait

        this.href = this.el.dataset.mbwaitHref

        this.promise = null
        this.active = 0

        //#region EventSource
        // this.evtSource = new EventSource(this.href + '?idPedido=' + this.idPedido);
        // this.evtSource.onmessage = e => {
        //     if ( e.data.substr(0,3) == 'END') {
        //         this.evtSource.close()
        //         this.evtSource = null
        //         return
        //     }

        //     var data = JSON.parse(e.data)

        //     if(data['message']) {
        //         // read new state
        //         this.el.children[this.active].classList.remove('active')
        //         this.el.children[this.active = data['message']].classList.add('active')
        //     }

        //     if(data['redirect']) {
        //         this.elLoading.classList.remove('active')
        //         window.location.replace(data['redirect']);
        //     }
        // };

        // window.addEventListener('unload', () => {
        //     if(this.evtSource) {
        //         this.evtSource.close()
        //         this.evtSource = null
        //     }
        // })
    //#endregion


        // check state every second but will only fetch every 5
        this.checks = 3
        this.seconds = 5
        this.interval = setInterval(() => this.checkMBWayState(), 1000)
    }

    //#region json js fetch
    checkMBWayState() {
        if(this.promise || this.checks++ < this.seconds) {
            return
        }

        this.checks = 0;

        this.promise = this.fetchData().then(data => {
            this.promise = null
            this.readData(data)
        })
    }

    fetchData() {
        let json = JSON.stringify({
            'idPedido': this.idPedido
        })

        console.log(window.location.origin + this.href)
        return fetch(window.location.origin + this.href
        ,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: json
        }
        ).then(response => response.json())
    }

    readData(data) {
        console.log(data)

        // read new state
        if(data['message']) {
            this.el.children[this.active].classList.remove('active')
            this.el.children[data['message']].classList.add('active')
            this.active = data['message']
        }

        // if(this.active == this.el.children.length - 2)
        // {
        //     this.el.children[this.active + 1].classList.remove('active')
        //     clearInterval(this.interval)
        // }

        if(data['redirect']) {
            window.location.replace(data['redirect']);
        }
    }
    //#endregion
}

export default MBWait